import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AppConfigService } from '@app/app-config.service';
import { RecaptchaService } from './recaptcha.service';

export const recaptchaInterceptor: HttpInterceptorFn = (req, next) => {
  const cfg = inject(AppConfigService);
  const recaptcha = inject(RecaptchaService);
  const apiBaseUrl = cfg.apiBaseUrl?.replace(/\/$/, '');
  const isApiRequest = apiBaseUrl ? req.url.startsWith(apiBaseUrl) : false;

  if (!isApiRequest) {
    return next(req);
  }

  const action = `rest_${req.method.toLowerCase()}`;
  return from(recaptcha.getToken(action)).pipe(
    switchMap((token) => {
      if (!token) {
        return next(req);
      }
      const withToken = req.clone({
        setHeaders: {
          'X-Recaptcha-Token': token
        }
      });
      return next(withToken);
    })
  );
};
